<template>
  <div>
    <b-modal
      id="copOf"
      ref="copOf"
      size="xl"
      :hide-footer="true"
      :no-close-on-esc="true"
      @hide="$emit('hide')"
    >
      <template #modal-header>
        <div class="d-flex align-items-center col-12">
          <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
          <span class="modalTitle ml-auto">
            {{$lang.PCI.COP.Official}}
          </span>
          <button class="close" @click="$emit('hide')">x</button>
        </div>
      </template>
      <input ref="UploadImgFile" type="file" style="display: none;" @change="onUploadFile" accept="image/*" />
      <input ref="UploadPdfFile" type="file" style="display: none;" @change="onUploadFile" accept="application/pdf" />
      <b-tabs>
        <b-tab title="Oficial">
          <b-row class="d-flex">
            <b-col cols="1">
              <b-row class="d-flex">
                <b-col cols="6" class="pl-1 pr-0" v-show="canEdit">
                  <b-button variant="third"
                            @click="addDates"
                            class="w-100">
                    <i class="far fa-calendar-plus" style="font-size: 16px;"></i>
                  </b-button>
                  <b-button variant="danger"
                            v-if="!isEmpty"
                            @click="deleteDates"
                            no-caret class="w-100 mt-1">
                    <i class="fa fa-trash"></i><span class="sr-only">{{$lang.Common.Buttons.Delete}}</span>
                  </b-button>
                </b-col>
                <b-col cols="6" class="pl-1 pr-0">
                  <b-button variant="info"
                            @click="printCop"
                            no-caret class="w-100">
                    <i class="fa fa-print"></i><span class="sr-only">{{'Imprime'}}</span>
                  </b-button>
                  <b-button variant="info"
                            @click="$emit('showTeam')"
                            no-caret class="w-100 mt-1">
                    <i class="fas fa-users"></i><span class="sr-only">{{'Imprime'}}</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row align-h="center">
                <b-form-group :label="$lang.PCI.COP.LabelCode" class="mx-2" style="width:100px;">
                  <b-form-input disabled v-model="copWorkData.code" class="text-center"></b-form-input>
                </b-form-group>
                <b-form-group :label="$lang.PCI.COP.LabelIdSite" class="mx-2" style="width:200px;">
                  <b-form-input disabled v-model="copWorkData.site" class="text-center"></b-form-input>
                </b-form-group>
                <b-form-group :label="$lang.PCI.COP.LabelContract" class="mx-2" style="width:250px;">
                  <b-form-input disabled v-model="copWorkData.contract" class="text-center"></b-form-input>
                </b-form-group>
                <b-form-group :label="$lang.PCI.COP.LabelSubisidiary" class="mx-2" style="width:60px;">
                  <b-form-input disabled v-model="copWorkData.subsidiarie" class="text-center"></b-form-input>
                </b-form-group>
                <b-form-group :label="$lang.PCI.COP.LabelType" class="mx-2" style="width:300px;">
                  <b-form-input disabled v-model="copWorkData.type" class="text-center"></b-form-input>
                </b-form-group>
                <b-form-group :label="$lang.PCI.COP.LabelDeadline" class="mx-2" style="width:50px;">
                  <b-form-input disabled v-model="copWorkData.deadline" class="text-center"></b-form-input>
                </b-form-group>
                <b-form-group :label="$lang.PCI.COP.LabelStopped" class="mx-2" style="width:50px;">
                  <b-form-input disabled v-model="copWorkData.stopped" class="text-center"></b-form-input>
                </b-form-group>
                <b-form-group :label="$lang.PCI.COP.LabelReal" class="mx-2" style="width:50px;">
                  <b-form-input disabled v-model="copWorkData.realDeadline" class="text-center"></b-form-input>
                </b-form-group>
              </b-row>
              <b-row align-h="center">
                <b-form-group :label="$lang.PCI.COP.LabelStatus" class="mx-2" style="width:150px;">
                  <b-input-group>
                    <b-form-input disabled v-model="workStatus" class="text-center" style="min-height: 32px;">
                    </b-form-input>
                    <b-input-group-append v-if="hasRole(roles.RW_OPER_PCI_ADM)">
                      <b-input-group-text class="p-0">
                        <i class="fas fa-pen" @click="onShowEditStatus" style="font-size:0.7rem; cursor:pointer; padding:0.5rem;"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-form-group :label="$lang.PCI.COP.LabelAtualization" class="mx-2" style="width:100px;">
                  <b-form-input disabled v-model="copWorkData.update" class="text-center"></b-form-input>
                </b-form-group>
                <b-form-group :label="$lang.PCI.COP.LabelAddress" class="mx-2" style="width:650px;">
                  <b-form-input disabled v-model="copWorkData.address" class="text-center"></b-form-input>
                </b-form-group>
              </b-row>
            </b-col>
          </b-row>

          <b-container fluid class="pl-0">
            <b-row>
              <b-col>
                <b-tabs class="cop-grid">
                  <b-tab :title="$lang.PCI.COP.Services">
                    <ag-grid-vue
                      ref="agCopServ"
                      id="ag-cop-serv"
                      class="ag-theme-alpine"
                      :getLocaleText="localeTextFunc"
                      :gridOptions="copServGridOptions"
                      :columnTypes="copColumnTypes"
                      :columnDefs="copServColumnDefs"
                      :rowData="copOfServData"
                      :getRowId="params => params.data.copModeloItemID"
                      :defaultColDef="copDefaultColumnDefs"
                      :getContextMenuItems="getContextMenuItems"
                      :getRowStyle="params => params.data.copModeloItem.dias === 0 ? {'font-weight': 'bolder'} : null"
                      style="height: calc(100% - 10px);"
                      suppressHorizontalScroll
                      @cellValueChanged="onEdit"
                      @firstDataRendered="params => params.api.sizeColumnsToFit()"
                      @gridReady="onGridCOPServiceReady"
                    >
                      <!-- :getRowId="params => params.data.id" -->
                    </ag-grid-vue>
                    <div class="d-flex mt-1">
                      <strong>* Item base em negrito</strong>
                    </div>
                  </b-tab>
                  <b-tab :title="$lang.PCI.COP.Obs">
                    <div class="d-flex flex-column" style="height: 100%;">
                      <div class="mb-1" v-if="isObsServUpdate">
                        <i class="fas fa-save mr-2" style="cursor:pointer;" @click="saveServObs"></i>
                        <i class="fas fa-ban" style="cursor:pointer;" @click="cancelServObs"></i>
                      </div>
                      <b-textarea
                        v-model="copOfObs.observacaoServico"
                        v-if="copOfObs"
                        style="height:75%;"
                        class="mb-1"
                        no-resize
                        @update="isObsServUpdate = true"
                        :disabled="!hasRole(roles.RW_OPER_PCI_ADM)"
                      />
                      <b-textarea
                        v-model="copOfObs.observacaoServicoAdd"
                        v-if="copOfObs"
                        style="height:25%;"
                        no-resize
                        @update="isObsServUpdate = true"
                        :disabled="!hasRole(roles.RW_OPER_PCI_ADM)"
                      />
                    </div>
                  </b-tab>
                  <b-tab :title="$lang.PCI.COP.Stoppage">
                    <div class="d-flex flex-column" style="height: calc(100vh - 430px);">
                      <b-textarea
                        v-model="copOfObs.observacaoParalisacao"
                        style="height: 100%;"
                        plaintext
                        no-resize
                        disabled
                      />
                    </div>
                  </b-tab>
                </b-tabs>
              </b-col>
              <b-col class="pr-0 pl-2">
                <b-tabs class="cop-grid">
                  <b-tab :title="$lang.PCI.COP.Documents">
                    <ag-grid-vue
                      ref="agCopDoc"
                      id="ag-cop-doc"
                      class="ag-theme-alpine"
                      :getLocaleText="localeTextFunc"
                      :gridOptions="copDocGridOptions"
                      :columnTypes="copColumnTypes"
                      :columnDefs="copDocColumnDefs"
                      :rowData="copOfDocData"
                      :getRowId="params => params.data.copModeloItemID"
                      :defaultColDef="copDefaultColumnDefs"
                      :getContextMenuItems="getContextMenuItems"
                      :getRowStyle="params => params.data.copModeloItem.dias === 0 ? {'font-weight': 'bolder'} : null"
                      style="height: calc(100% - 10px);"
                      suppressHorizontalScroll
                      @cellValueChanged="onEdit"
                      @firstDataRendered="params => params.api.sizeColumnsToFit()"
                      @gridReady="onGridCOPDocReady"
                    >
                      <!-- :getRowId="params => params.data.id" -->
                    </ag-grid-vue>
                    <div class="d-flex mt-1">
                      <strong>* Item base em negrito</strong>
                    </div>
                  </b-tab>

                  <b-tab :title="$lang.PCI.COP.Obs">
                    <div class="d-flex flex-column" style="height: 100%;">
                      <div class="mb-1" v-if="isObsDocUpdate">
                        <i class="fas fa-save mr-2" style="cursor:pointer;" @click="saveDocObs"></i>
                        <i class="fas fa-ban" style="cursor:pointer;" @click="cancelDocObs"></i>
                      </div>
                      <b-textarea
                        v-model="copOfObs.observacaoDocumento"
                        v-if="copOfObs"
                        style="height:75%;"
                        class="mb-1"
                        no-resize
                        @update="isObsDocUpdate = true"
                        :disabled="!hasRole(roles.RW_OPER_PCI_ADM)"
                      />
                      <b-textarea
                        v-model="copOfObs.observacaoDocumentoAdd"
                        v-if="copOfObs"
                        style="height:25%;"
                        no-resize
                        @update="isObsDocUpdate = true"
                        :disabled="!hasRole(roles.RW_OPER_PCI_ADM)"
                      />
                    </div>
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
          </b-container>
        </b-tab>
      </b-tabs>
    </b-modal>

    <!-- Visualização IMG COP -->
    <b-modal
      :title="$lang.PCI.COP.ViewFile"
      v-model="showCopImg"
      size="xl"
      hide-footer
      id="copImg"
    >
      <div class="d-flex flex-row">
        <div v-if="showCopImg === true" class="d-flex flex-grow-1 align-items-center h-100">
          <img
            v-for="(file, key) in copImg"
            :key="`cop-img-${key}`"
            :src="`data:${file.type};base64,${file.src}`"
            class="copImg"
          >
        </div>
        <div>
          <i class="far fa-window-restore" style="font-size: 2rem;" v-b-tooltip.hover :title="'Abrir em nova aba'" @click="onShowImageNewWindow"></i>
        </div>
      </div>
    </b-modal>

    <!-- Visualização PDF COP -->
    <b-modal
      :title="$lang.PCI.COP.ViewFile"
      v-model="showCopPdf"
      v-if="showCopPdf"
      size="xl"
      hide-footer
      id="copPdf"
    >
      <object
        width="100%"
        height="100%"
        class="copPdf"
        type="application/pdf"
        :data="copPdf"
        v-if="copPdf !== null"
      />
    </b-modal>

    <!-- Incluir datas COP -->
    <b-modal :title="copDatesTitle"
             v-model="showCopDates"
             size="lg"
             hide-footer>
      <div>
        <b-row>
          <b-col cols="4" v-if="copDatesType === 'add'">
            <span>{{$lang.PCI.COP.Dates.LabelBaseDate}}</span>
            <span><b-form-input v-model="formCOPAddDatas.dataBase" type="date" /></span>
          </b-col>
          <b-col cols="4">
            <b-form-group :label="$lang.PCI.COP.LabelDestiny">
              <b-form-radio v-model="formCOPAddDatas.tipo" name="some-radios" value="2">{{$lang.PCI.COP.Documents}}</b-form-radio>
              <b-form-radio v-model="formCOPAddDatas.tipo" name="some-radios" value="1">{{$lang.PCI.COP.Services}}</b-form-radio>
            </b-form-group>
          </b-col>
          <b-col cols="4" v-if="formCOPAddDatas.tipo == 1 && copDatesType === 'add'">
            <span>{{$lang.PCI.COP.Dates.LabelDaysToAdd}}</span>
            <span><b-form-input v-model="formCOPAddDatas.diasMeta" type="number" /></span>
          </b-col>
        </b-row>
        <b-button variant="third" @click="saveDates" class="mt-3">
          <i class="fas fa-save"></i>
          {{$lang.Common.Buttons.Save}}
        </b-button>
      </div>
    </b-modal>

    <b-modal :title="$lang.PCI.COP.EditStatus.Title"
             v-model="showEditStatus"
             v-if="showEditStatus"
             size="md"
             ok-only
             :ok-title="$lang.Common.Buttons.Save"
             ok-variant="third"
             @ok="onChangeStatus">
      <div class="d-flex">
        <b-form-group :label="$lang.PCI.COP.LabelStatus" class="col-6">
          <b-form-select v-model="changeStatusObj.situacao"
                        :options="[
                          {value: 1, text: $lang.PCI.COP.Status1},
                          {value: 2, text: $lang.PCI.COP.Status2},
                          {value: 3, text: $lang.PCI.COP.Status3},
                          {value: 4, text: $lang.PCI.COP.Status4},
                          {value: 5, text: $lang.PCI.COP.Status5},
                          {value: 6, text: $lang.PCI.COP.Status6},
                          {value: 7, text: $lang.PCI.COP.Status7},
                          {value: 8, text: $lang.PCI.COP.Status8},
                        ]">
          </b-form-select>
        </b-form-group>
        <b-form-group :label="$lang.PCI.COP.EditStatus.LabelDate" class="col-6">
          <b-form-input type="date" v-model="changeStatusObj.data"></b-form-input>
        </b-form-group>
      </div>
    </b-modal>

    <div id="printDiv"></div>
  </div>
</template>

<script>
import Cop from './cop'
export default Cop
</script>

<style scoped>
  .work-data span:first-of-type {
    color: #008143;
    font-weight: 700;
    display: flex;
    flex-direction: column;
  }

  .work-data {
    text-align: center;
    margin: 0 0.75rem 0.25rem;
    width: 15%;
  }

  .work-data:last-of-type {
    width: auto;
  }

  .copImg,
  .copPdf {
    display: block;
    margin: auto;
    height: calc(100vh - 160px);
    object-fit: contain;
    max-width: 100%;
  }

  .cop-grid {
    width: 100%;
    height: calc(100vh - 370px);
  }

  .cop-grid >>> .tab-content {
    height: calc(100% - 30px);
  }

  .tab-pane {
    height: 100%;
  }

  .copPrintBody {
    overflow-y: auto;
    height: calc(100vh - 220px);
  }

  * >>> .cop-grid div.ag-root-wrapper * {
    font-size: 0.66rem !important;
    text-align: center !important;
  }

  /* * >>> .cop-grid * {
    font-size: 0.66rem !important;
    text-align: left !important;
  } */

  * >>> .cop-grid .ag-cell,
  * >>> .cop-grid .ag-header-cell {
    padding-left: 3px !important;
    padding-right: 3px !important;
  }

  * >>> #copOf .ag-center-cols-viewport {
    overflow-x: hidden !important;
  }
  * >>> .modal-header {
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
  }
  * >>> .modal-body {
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    overflow: hidden;
  }
  * >>> .modal-footer {
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
  }
  * >>> .modal-content {
    border-radius: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/cop/cop.vue